import { formatToMoney } from 'utils';
import { Icon, Icons } from './Icon';
import Button from './Form/Button';
import { Link } from 'react-router-dom';

type Props = {
  iWillLogo: string;
  iWillPrice: number;
  iWillPackages: { title: string; info: string }[];
  iWillPlanId: number;
  iWillContent?: string;
  isRecommended: boolean;
  isUseLink?: boolean;
  onPlanSelect?: () => void;
  isSelectedPlan?: boolean;
  onSubmit?: () => void;
};

export default function IWillPlan({
  iWillLogo,
  iWillPrice,
  iWillPackages,
  iWillPlanId,
  iWillContent,
  isRecommended,
  isUseLink = true,
  onPlanSelect,
  isSelectedPlan,
  onSubmit
}: Props) {
  return (
    <div className="flex flex-col items-center gap-y-2">
      {isRecommended ? (
        <Button
          variant="primary"
          size="md"
          className="mt-10 w-full rounded-t-[10px] p-[0.1rem]"
          label="RECOMMENDED"
          type="button"
        ></Button>
      ) : (
        <div className="h-[5.2rem]"></div>
      )}
      <div
        className={`flex h-[835px] cursor-pointer flex-col items-center justify-between rounded-[10px] border-[3px] ${
          isSelectedPlan ? 'border-[#FF6606]' : 'border-[#FF660626]'
        }  px-5 py-20 pb-10`}
        onClick={onPlanSelect}
      >
        <div className="flex flex-col">
          <div className="flex flex-col items-center text-center">
            <img
              src={iWillLogo}
              alt="I Will logo"
              className="mb-4 w-16 object-contain"
            />

            <p className="my-8 text-center font-circular text-3xl font-semibold text-[#353535]">
              {formatToMoney(iWillPrice)}
            </p>

            <div
              className={`mb-5 w-3/4 border-t-2 ${
                isRecommended ? 'border-[#FF6606]' : 'border-[#35353533]'
              }`}
            />
          </div>
          <p className="mx-auto mb-10 max-w-[280px] text-sm leading-6 text-[#353535B3]">
            {iWillContent}
          </p>

          <div className="flex flex-col gap-5">
            {iWillPackages.map(packages => (
              <div
                key={packages.title}
                className="flex items-center justify-between gap-4"
              >
                <p className="font-circular text-sm font-bold text-[#353535]">
                  {packages.title}
                </p>

                <Icon name={Icons.CheckMark} />
              </div>
            ))}
          </div>
        </div>
        {isUseLink ? (
          <Link to={`/get-started/setup-account/${iWillPlanId}`}>
            <Button
              variant="primary"
              size="md"
              className="w-[7rem] rounded p-[0.1rem]"
              label="Get Started"
            ></Button>
          </Link>
        ) : (
          <Button
            variant="primary"
            size="md"
            className="w-[7rem] rounded p-[0.1rem]"
            label="Get Started"
            type="button"
            onClick={onSubmit}
          ></Button>
        )}
      </div>
    </div>
  );
}
